import SubHeaders from '@/components/Headers/SubHeaders'
import AddIcons from '@/icons/AddIcons'
import useTabs from '@/hooks/useTabs'
import { paths } from '@/utils/path'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Tabs } from 'vnetwork-ui'
import DashboardStats from './DashboardStats'
import { tabs } from './tabs'

const List = () => {
    const { t } = useTranslation('reseller')
    const navigate = useNavigate()
    const { TabComponent, TabProps } = useTabs({
        tabs: tabs(t),
        clearFilters: true,
    })

    return (
        <div>
            <SubHeaders
                actions={[
                    {
                        icon: <AddIcons />,
                        label: t('add_reseller'),
                        onClick() {
                            navigate(paths.resellerCreate)
                        },
                    },
                ]}
                breadcrumbs={[
                    {
                        path: paths.resellersList,
                        title: t('reseller_manager'),
                    },
                ]}
            />
            <DashboardStats />
            <Tabs {...TabProps} />
            {TabComponent}
        </div>
    )
}

export default List
